import React from 'react';
import { FormGroup, Input } from 'reactstrap';
import './StyledInput.css';

function StyledInput({ label, id, inputRef, ...props }) {
  return (
    <FormGroup className="mui-form-group">
      <Input
        id={id}
        className="mui-input"
        placeholder=" "
        innerRef={inputRef}
        {...props}
      />
      <label htmlFor={id} className="mui-label">{label}</label>
    </FormGroup>
  );
}

export default StyledInput;
